<div class="summary-info">
  <div class="summary-info-header">
    <div class="name">
      <app-text-with-placeholder [showPlaceholder]="isLoading">{{
        $safeNavigationMigration(user?.name) | titlecase
      }}</app-text-with-placeholder>
    </div>

    @if (customerType === 'business') {
      <div class="header-row user-name">
        <app-text-with-placeholder [showPlaceholder]="isLoading">{{ user?.businessContactName }}</app-text-with-placeholder>
      </div>
    }
  </div>

  <div class="summary-info-body">
    <div class="title">{{ isBusinessCustomer ? 'Business' : 'Primary' }} Information</div>

    <div class="body-row">
      <div class="row-icon"><rkt-icon name="phone"></rkt-icon></div>
      <div class="row-value" [class.no-value]="!user?.phoneNumber">
        <app-text-with-placeholder [showPlaceholder]="isLoading">{{
          $safeNavigationMigration(user?.phoneNumber) | phone | notAvailable
        }}</app-text-with-placeholder>
      </div>
    </div>

    @if (!isBusinessCustomer) {
      <div class="body-row">
        <div class="row-icon"><rkt-icon name="mail"></rkt-icon></div>
        <div class="row-value" [class.no-value]="!user?.email">
          <app-text-with-placeholder [showPlaceholder]="isLoading">{{
            $safeNavigationMigration(user?.email) | notAvailable
          }}</app-text-with-placeholder>
        </div>
      </div>
    }

    @if (!isCounterparty) {
      <div class="body-row">
        <div class="row-icon"><rkt-icon name="location"></rkt-icon></div>
        <div class="row-value" [class.no-value]="!user?.address">
          <app-text-with-placeholder [showPlaceholder]="isLoading">{{
            $safeNavigationMigration(user?.address) | notAvailable
          }}</app-text-with-placeholder>
        </div>
      </div>
    }
  </div>

  @if (!isCounterparty && user?.sex) {
    <div class="summary-info-block">
      <div class="details-row">
        <app-details-item [showPlaceholder]="isLoading" [class.no-value]="!user?.sex" label="Sex" [value]="userGender"></app-details-item>
      </div>
    </div>
  }

  @if (!isCounterparty) {
    <div class="summary-info-block footer-section">
      <a class="details-link" routerLink="../detailed-profile">View more information</a>
    </div>
  }
</div>
